const SHIPMENT_ITEM_STATUSES = {
  PENDING   : 'pending',
  PACKED    : 'packed',
  CANCELLED : 'cancelled',
  SHIPPED   : 'shipped'
}

export default SHIPMENT_ITEM_STATUSES